import * as React from 'react';
import { motion } from 'framer-motion';
import { get } from 'lodash';
import styled from 'styled-components';

import { HEX_PLANS } from '../../data/plans';
import { ANIMATIONS } from '../../utils';
import { Button, Heading, Text } from '../design-system';

import { ReadyToGetStartedItem } from './ReadyToGetStartedItem';

const Wrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 60px 40px 80px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    padding-top: 40px;
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    padding: 40px 30px 60px;
  }
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 1060px;
  margin: 0 auto;
`;

const Description = styled(Text).attrs({ size: 'medium' })`
  text-align: center;
  margin-bottom: 50px;
  max-width: 475px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    margin-bottom: 30px;
    padding: 0;
  }
`;

const Plans = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 25px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    display: flex;
    flex-direction: column;
  }
`;

const Action = styled.div`
  margin-top: 60px;
`;

export const ReadyToGetStartedTout: React.ComponentType = React.memo(() => {
  return (
    <Wrapper {...ANIMATIONS.SimpleFadeIn}>
      <Inner>
        <Heading
          css={`
            margin-bottom: 15px;
            text-align: center;
          `}
          renderAs="h2">
          Ready to get started?
        </Heading>
        <Description>
          You can use Hex in two ways: our centrally-hosted Hex Cloud stack, or
          a private single-tenant VPC.
        </Description>
        <Plans>
          {Object.keys(HEX_PLANS.Info).map(name => {
            const plan = get(HEX_PLANS.Info, name);
            return <ReadyToGetStartedItem key={name} name={name} plan={plan} />;
          })}
        </Plans>
        <Action>
          <Button
            link="/pricing/"
            size="large"
            stylez="loud"
            text="View pricing details"
          />
        </Action>
      </Inner>
    </Wrapper>
  );
});
